import api from "@/api";
import InspectionSheet from "@/models/InspectionSheet";
const state = {
  inspectionSheet: {},
  list: { data: [], paging: {} },
  DOCS: []
};
const getters = {
  inspectionSheet: state => {
    return state.inspectionSheet;
  },
  list: state => {
    return state.list;
  },
  docs: state => {
    return state.DOCS;
  }
};
const actions = {
  setInspectionSheet({ commit }, payload) {
    commit("set_inspectionSheet", payload);
  },
  clearInspection({ commit }) {
    commit("CLEAR_INSPECTION");
  },
  async getList({ commit }, params) {
    const result = await api.get(`/api/v1/inventory/view_materials`, params);
    if (result && result.status == 200) {
      commit("set_list", result.data);
      return result.data;
    }
    return null;
  },
  getDocs({ commit }, params) {
    InspectionSheet.getDocuments(params).then(resp => {
      if (resp) {
        // for (let doc of resp) {
        //   this.docs.push(doc);
        // }
        commit("SET_DOCS", resp);
      }
    });
  }
};
const mutations = {
  set_inspectionSheet: (state, payload) => {
    state.inspectionSheet = payload;
  },
  set_list: (state, payload) => {
    state.list = payload;
  },
  CLEAR_INSPECTION: state => {
    state.inspectionSheet = {};
    state.DOCS = [];
  },
  SET_DOCS: (state, payload) => {
    state.DOCS = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
